import React from 'react'
import Grid from '@mui/material/Grid'
import TagSelector from '../tags/TagSelector'

/**
 * Shared tag selector section used by admin modals and creation forms.
 * Renders all shared resource tag selectors in a consistent layout.
 *
 * Props:
 *   contentTags, setContentTags
 *   medicalTags, setMedicalTags
 *   adminCategoryTags, setAdminCategoryTags
 *   experienceTags, setExperienceTags
 *   demographicTags, setDemographicTags
 *   required: boolean (default false) — marks tag selectors as required (used in forms)
 *   forceShowRequiredErrors: boolean (default false) — forces required selectors to show inline errors
 */
const ResourceTagsSection = ({
    contentTags, setContentTags,
    medicalTags, setMedicalTags,
    adminCategoryTags, setAdminCategoryTags,
    experienceTags, setExperienceTags,
    demographicTags, setDemographicTags,
    required = false,
    forceShowRequiredErrors = false,
}) => {
    return (
        <>
            <Grid item xs={12} md={6}>
                <TagSelector
                    tagType="content"
                    selectedTags={contentTags}
                    onChange={setContentTags}
                    multiple={true}
                    label="Content Keywords"
                    required={required}
                    maxTags={5}
                    forceShowErrors={forceShowRequiredErrors}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <TagSelector
                    tagType="medicalSpecialty"
                    selectedTags={medicalTags}
                    onChange={setMedicalTags}
                    multiple={true}
                    label="Medical Specialty"
                    maxTags={5}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <TagSelector
                    tagType="adminCategory"
                    selectedTags={adminCategoryTags}
                    onChange={setAdminCategoryTags}
                    multiple={true}
                    label="Admin Category"
                    required={required}
                    maxTags={5}
                    forceShowErrors={forceShowRequiredErrors}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <TagSelector
                    tagType="experience"
                    selectedTags={experienceTags}
                    onChange={setExperienceTags}
                    multiple={true}
                    label="Experience Level"
                    required={required}
                    maxTags={5}
                    forceShowErrors={forceShowRequiredErrors}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <TagSelector
                    tagType="demographic"
                    selectedTags={demographicTags}
                    onChange={setDemographicTags}
                    multiple={true}
                    label="Demographic"
                    required={required}
                    maxTags={5}
                    forceShowErrors={forceShowRequiredErrors}
                />
            </Grid>
        </>
    )
}

export default ResourceTagsSection
